module.exports = __webpack_public_path__ + "img/upload-documents.3bd384df.png";